import { Skeleton } from '@mui/material'
import React from 'react'

type Props = {}

const MainSkeleton = (props: Props) => {
    return (
        <div className='w-full h-screen border-red-600 flex gap-1'>
            <Skeleton variant="rounded" height={"100%"} className='w-full max-w-[16%]' />
            <span className='w-full flex flex-col gap-1'>
                <Skeleton variant="rounded" height={"8%"} className='w-full' />
                <Skeleton variant="rounded" height={"92%"} className='w-full' />
            </span>
        </div>
    )
}

export default MainSkeleton